'use client';

import { FC, useEffect } from 'react';
import { IntroText } from '@/components/IntroText';
import { Container } from '@/components/PageLevelComponents/PageLevelLayouts/Layouts';
import { PopularSearch } from '@/components/PopularSearch';
import type { IPopularSearchData, ISearchOverlayTitles } from '@/components/SearchOverlay/types';
import { TrackingService } from '@/service/tracking/trackingService';
import { RecipeSearchResults } from '@/components/RecipeSearchResults';

interface ClientRecipeNotFoundPageProps {
  popularSearchData?: IPopularSearchData;
  slug: string;
  searchOverlayData?: ISearchOverlayTitles;
  locale: string;
  titleRecipe: string;
  descriptionRecipe: string;
}

const ClientRecipeNotFoundPage: FC<ClientRecipeNotFoundPageProps> = ({
  popularSearchData,
  slug,
  searchOverlayData,
  locale,
  titleRecipe,
  descriptionRecipe,
}) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      TrackingService.contentGroups({
        cg1: 'error page',
      });
      TrackingService.pageValues(
        locale.slice(3, 5) || '',
        locale.slice(0, 2).toUpperCase() || '',
        window.location.pathname || '',
      );
    }
  }, []);

  const handleClickPopularSearch = (item: any, index: number) => {
    TrackingService.clickPopularSearch(item, index);
  };

  return (
    <Container className="flex flex-col justify-center w-full text-center min-h-screen recipe-not-found">
      <IntroText title={titleRecipe} description={descriptionRecipe} />
      <div className="w-full md:w-2/3">
        <RecipeSearchResults searchOverlayData={searchOverlayData} slug={slug} />
      </div>
      <div className="w-full">
        <PopularSearch
          componentData={popularSearchData?.componentData}
          hits={popularSearchData?.hits}
          trackingEvents={{ clickPopularSearch: handleClickPopularSearch }}
        />
      </div>
    </Container>
  );
};

export default ClientRecipeNotFoundPage;
